module.exports = __webpack_public_path__ + "static/media/DSC_6421.acf79973.jpg";